import React from "react";
import { Modal as BSModal } from "react-bootstrap";
import { Icon } from "../../Elements";

export interface ModalProps {
	children: React.ReactNode;
	show: boolean;
	setShow: (...args: any[]) => void;
	id?: string;
	size?: "sm" | "md" | "lg" | "xl";
	title?: string | React.ReactNode;
	footerButtons?: React.ReactNode[];
	closeButton?: boolean;
	disableClose?: boolean;
	centered?: boolean;
	className?: string;
}

const Modal: React.FC<ModalProps> = ({
	children,
	centered = true,
	show,
	setShow,
	id = "modal",
	title,
	footerButtons,
	size = "lg",
	closeButton = true,
	disableClose = false,
	className,
}) => {
	return (
		<BSModal
			size={size === "md" ? undefined : size}
			show={show}
			onHide={() => {
				if (!disableClose) {
					setShow(false);
				}
			}}
			aria-labelledby={`${id}-title`}
			centered={centered}
			className={className}
		>
			{(title || closeButton) && (
				<div className={`modal-header${!title ? " titleless" : ""}`}>
					{title && (
						<div className="modal-title h4" id="modal-title">
							{title}
						</div>
					)}
					{closeButton && (
						<button
							type="button"
							className="close"
							onClick={() => {
								if (!disableClose) {
									setShow(false);
								}
							}}
						>
							<span aria-hidden="true">
								<Icon icon="times" />
							</span>
							<span className="sr-only">Close</span>
						</button>
					)}
				</div>
			)}
			<BSModal.Body>{children}</BSModal.Body>
			{footerButtons && footerButtons.length > 0 && (
				<BSModal.Footer>
					{footerButtons.map((footerButton) => {
						return footerButton;
					})}
				</BSModal.Footer>
			)}
		</BSModal>
	);
};

export default Modal;
